(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-bubble-cuddle-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  function arrangeBubbleRewards(){
    if(!document.querySelector('.rd-bubble')) return;
    const section=document.querySelector('.rd-bubble-buy')?.closest('.product-section');
    if(!section) return;
    const priceBlock=section.querySelector('.product-block--price');
    const cashback=section.querySelector('.koin-promotion-widget')?.closest('.shopify-app-block');
    if(priceBlock && cashback && priceBlock.nextElementSibling!==cashback){
      cashback.classList.add('rd-bubble-cashback-position');
      priceBlock.after(cashback);
    }
    section.querySelectorAll('.ahlGiftBnrTitle').forEach(function(title){
      if(title.textContent==='Free gift if you order this item – Add to cart to claim' || title.textContent==='Complimentary gift') title.textContent='Add to cart to unlock your gift';
    });
    section.querySelectorAll('.ahlGiftBnrPrdTitle>span').forEach(function(title){
      const original=title.textContent.replace(/^GIFT:\s*/,'').trim();
      const text=/100% Cotton Embroidered Towel/i.test(original) ? 'Cotton guest towel' : original;
      if(title.textContent!==text) title.textContent=text;
    });
  }
  function start(){
    if(!document.querySelector('.rd-bubble')) return;
    arrangeBubbleRewards();
    document.querySelectorAll('.product-section .collapsibles-wrapper .collapsible-trigger-btn').forEach(function(button){
      if(button.dataset.rdBubbleAccordion) return;
      button.dataset.rdBubbleAccordion='true';
      const panel=document.getElementById(button.getAttribute('aria-controls'));
      if(!panel) return;
      function setOpen(target,open){
        const content=document.getElementById(target.getAttribute('aria-controls'));
        target.setAttribute('aria-expanded',String(open));
        target.classList.toggle('is-open',open);
        content.classList.toggle('is-open',open);
        content.setAttribute('aria-hidden',String(!open));
      }
      document.addEventListener('click',function(event){
        if(!button.contains(event.target)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const open=button.getAttribute('aria-expanded')!=='true';
        button.closest('.product-section').querySelectorAll('.collapsibles-wrapper .collapsible-trigger-btn').forEach(function(other){
          setOpen(other,other===button && open);
        });
      },true);
    });
    const section=document.querySelector('.rd-bubble-buy')?.closest('.product-section');
    if(section) new MutationObserver(arrangeBubbleRewards).observe(section,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-signature-duvet-story"] && !Shopify.designMode) return;
  try {
    
  function rdHideSignatureUtilityLabels() {
    const main = document.querySelector('.product-single__meta');
    if (!main) return;
    main.querySelectorAll('.product-block').forEach((block) => {
      const text = block.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text.includes('free shipping') || text.includes('in stock')) block.style.setProperty('display', 'none', 'important');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rdHideSignatureUtilityLabels);
  else rdHideSignatureUtilityLabels();
  new MutationObserver(rdHideSignatureUtilityLabels).observe(document.documentElement, { childList: true, subtree: true });

  function rdPlaceSignaturePolicy() {
    const policy = document.querySelector('.rd-signature-policy');
    const gift = document.querySelector('[id^="ahlGiftBnr"]');
    const main = document.querySelector('.product-single__meta');
    if (!policy || !main) return;
    const cashback = Array.from(main.querySelectorAll('[id*="koin_promotion_widget"]')).find((block) => block.textContent.toLowerCase().includes('cashback'));
    const priceBlock = main.querySelector('.product-block--price');
    const buy = main.querySelector('.rd-signature-buy');
    const selector = main.querySelector('.rd-option-selector,.variant-wrapper');
    const selectorBlock = selector?.closest('.product-block');
    const quantityBlock = selectorBlock?.nextElementSibling;
    const button = main.querySelector('.add-to-cart');
    const buttonBlock = button?.closest('.product-block') || button?.closest('form');
    if (cashback && priceBlock && priceBlock.nextElementSibling !== cashback) priceBlock.after(cashback);
    if (buy && cashback && cashback.nextElementSibling !== buy) cashback.after(buy);
    let shell = main.querySelector('.rd-signature-purchase-shell');
    if (!shell && selectorBlock && buttonBlock) {
      shell = document.createElement('div');
      shell.className = 'rd-signature-purchase-shell';
      selectorBlock.before(shell);
      shell.append(selectorBlock);
      if (quantityBlock && quantityBlock !== buttonBlock) shell.append(quantityBlock);
      shell.append(buttonBlock);
    }
    if (gift && policy && policy.nextElementSibling !== gift) policy.after(gift);
    if (gift) {
      const title = gift.querySelector('.ahlGiftBnrTitle');
      const productTitle = gift.querySelector('.ahlGiftBnrPrdTitle');
      if (title && /^(Free gift if you order this item|Complimentary gift)/.test(title.textContent)) title.textContent = 'Add to cart to unlock your gift';
      if (productTitle && /^GIFT:\s*/i.test(productTitle.textContent)) productTitle.textContent = productTitle.textContent.replace(/^GIFT:\s*/i, '');
    }
    if (shell && policy.parentElement !== shell) shell.append(policy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rdPlaceSignaturePolicy);
  else rdPlaceSignaturePolicy();
  new MutationObserver(rdPlaceSignaturePolicy).observe(document.documentElement, { childList: true, subtree: true });

  function rdEnhanceSignatureSelectorPreview() {
    return;
    const main = document.querySelector('.product-single__meta');
    const section = document.querySelector('.rd-signature');
    const panel = main && main.querySelector('.rd-option-selector__panel');
    const data = section && section.querySelector('[data-rd-signature-preview-variants]');
    const priceRow = panel && panel.querySelector('.rd-option-selector__price-row');
    if (!main || !section || !panel || !data || !priceRow) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }
    let preview = priceRow.querySelector('.rd-signature-option-preview');
    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'rd-signature-option-preview';
      preview.innerHTML = '<img alt="" width="68" height="68"><span><small>Selected colour</small><strong></strong></span>';
      priceRow.prepend(preview);
    }
    const label = main.querySelector('.rd-option-selector__label');
    if (label && label.firstChild) label.firstChild.textContent = window.matchMedia('(max-width: 749px)').matches ? 'Choose options ' : 'Choose your size & colour ';
    const update = () => {
      const selected = Array.from(panel.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option) => selected.includes(option)));
      const colorInput = panel.querySelector('fieldset[name="Color"] input:checked');
      const color = colorInput ? colorInput.value : selected[selected.length - 1];
      let image = variant && variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
      if (color === 'White' && section.dataset.rdWhitePreview) image = section.dataset.rdWhitePreview;
      const img = preview.querySelector('img');
      const colorLabel = color || 'Selected option';
      const strong = preview.querySelector('strong');
      if (strong.textContent !== colorLabel) strong.textContent = colorLabel;
      if (image) {
        img.src = image;
        img.alt = `${color || 'Selected'} ${document.querySelector('h1')?.textContent.trim() || 'product'}`;
      }
    };
    if (!panel.dataset.rdPreviewReady) {
      panel.dataset.rdPreviewReady = 'true';
      panel.addEventListener('change', () => window.requestAnimationFrame(update));
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rdEnhanceSignatureSelectorPreview);
  else rdEnhanceSignatureSelectorPreview();
  new MutationObserver(rdEnhanceSignatureSelectorPreview).observe(document.documentElement, { childList: true, subtree: true });

  function rdAnimateSignatureFillPower() {
    document.querySelectorAll('.rd-signature__bar-card:not([data-scroll-ready])').forEach((card) => {
      card.dataset.scrollReady = 'true';
      if (!('IntersectionObserver' in window)) {
        card.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.45 });
      observer.observe(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rdAnimateSignatureFillPower);
  else rdAnimateSignatureFillPower();
  document.addEventListener('shopify:section:load', rdAnimateSignatureFillPower);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-signature-pillow-story"] && !Shopify.designMode) return;
  try {
    
function rdHidePillowUtilityLabels(){const main=document.querySelector('.product-single__meta');if(!main)return;main.querySelectorAll('.product-block').forEach(block=>{const text=block.textContent.replace(/\s+/g,' ').trim().toLowerCase();if(text.includes('free shipping')||text.includes('in stock'))block.style.setProperty('display','none','important')})}
function rdEnhancePillowSelectorPreview(){return;const main=document.querySelector('.product-single__meta');const panel=main&&main.querySelector('.rd-option-selector__panel');if(!main||!panel)return;const label=main.querySelector('.rd-option-selector__label');const labelText=window.matchMedia('(max-width: 749px)').matches?'Choose options ':'Choose your size ';if(label&&label.firstChild&&label.firstChild.textContent!==labelText)label.firstChild.textContent=labelText;const colorField=panel.querySelector('fieldset[name="Color"]');if(!colorField){panel.querySelector('.rd-pillow-option-preview')?.remove();return}const section=document.querySelector('.rd-pillow');const data=section&&section.querySelector('[data-rd-pillow-preview-variants]');const priceRow=panel.querySelector('.rd-option-selector__price-row');if(!section||!data||!priceRow)return;let variants;try{variants=JSON.parse(data.textContent)}catch(error){return}let preview=priceRow.querySelector('.rd-pillow-option-preview');if(!preview){preview=document.createElement('div');preview.className='rd-pillow-option-preview';preview.innerHTML='<img alt="" width="68" height="68"><span><small>Selected colour</small><strong></strong></span>';priceRow.prepend(preview)}const update=()=>{const selected=Array.from(panel.querySelectorAll('input[type="radio"]:checked')).map(input=>input.value);const variant=variants.find(item=>item.options.every(option=>selected.includes(option)));const color=colorField.querySelector('input:checked')?.value;const image=variant&&variant.featured_image&&(variant.featured_image.src||variant.featured_image.url);const strong=preview.querySelector('strong');const selectedColor=color||'Selected colour';if(strong&&strong.textContent!==selectedColor)strong.textContent=selectedColor;if(image){const img=preview.querySelector('img');if(img.src!==image)img.src=image;img.alt=`${color||'Selected'} ${document.querySelector('h1')?.textContent.trim()||'product'}`}};if(!panel.dataset.rdPreviewReady){panel.dataset.rdPreviewReady='true';panel.addEventListener('change',()=>window.requestAnimationFrame(update))}update()}
function rdEnhancePillowPurchase(){rdHidePillowUtilityLabels();const main=document.querySelector('.product-single__meta');if(!main)return;const selector=main.querySelector('.rd-option-selector,.variant-wrapper');const selectorBlock=selector&&selector.closest('.product-block');if(selectorBlock&&!main.querySelector('.rd-pillow-buy'))selectorBlock.insertAdjacentHTML('beforebegin','<div class="rd-pillow-buy"><p class="rd-pillow-buy__lead">Our most luxurious pillow pair, freshly filled to order with 100% goose down for cloud-like softness and gentle support.</p><div class="rd-pillow-buy__benefits"><div><strong>Pure goose down</strong><span>100% goose down</span></div><div><strong>Resilient loft</strong><span>700 fill power</span></div><div><strong>Freshly filled</strong><span>Made to order</span></div></div></div>');const buy=main.querySelector('.rd-pillow-buy');const priceBlock=main.querySelector('.product-block--price');const button=main.querySelector('.add-to-cart');const buttonBlock=button&&(button.closest('.product-block')||button.closest('form'));if(buttonBlock&&!main.querySelector('.rd-pillow-policy'))buttonBlock.insertAdjacentHTML('afterend','<div class="rd-pillow-policy"><svg aria-hidden="true" viewBox="0 0 24 24" width="19" height="19" fill="none"><path d="M12 3.5 19 6v5.2c0 4.4-2.8 7.6-7 9.3-4.2-1.7-7-4.9-7-9.3V6l7-2.5Z" stroke="currentColor" stroke-width="1.4"/><path d="m8.8 12 2.1 2.1 4.5-4.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg><p>Please choose your size carefully. For hygiene reasons, pillows cannot be returned or exchanged.</p></div>');const policy=main.querySelector('.rd-pillow-policy');const cashback=Array.from(main.querySelectorAll('[id*="koin_promotion_widget"]')).find(block=>block.textContent.toLowerCase().includes('cashback'));const gift=Array.from(main.querySelectorAll('[id^="ahlGiftBnr"]')).find(block=>!block.classList.contains('rd-pillow-gift-fallback'));if(cashback&&priceBlock&&priceBlock.nextElementSibling!==cashback)priceBlock.after(cashback);if(buy&&cashback&&cashback.nextElementSibling!==buy)cashback.after(buy);let shell=main.querySelector('.rd-pillow-purchase-shell');if(!shell&&selectorBlock&&buttonBlock){const quantityBlock=selectorBlock.nextElementSibling;shell=document.createElement('div');shell.className='rd-pillow-purchase-shell';selectorBlock.before(shell);shell.append(selectorBlock);if(quantityBlock&&quantityBlock!==buttonBlock)shell.append(quantityBlock);shell.append(buttonBlock)}if(policy&&shell&&policy.parentElement!==shell)shell.append(policy);if(gift){main.querySelector('.rd-pillow-gift-fallback')?.remove();if(policy&&policy.nextElementSibling!==gift)policy.after(gift);const title=gift.querySelector('.ahlGiftBnrTitle');const productTitle=gift.querySelector('.ahlGiftBnrPrdTitle');if(title&&/^(Free gift if you order this item|Complimentary gift)/.test(title.textContent.trim()))title.textContent='Add to cart to unlock your gift';if(productTitle&&/^GIFT:\s*/i.test(productTitle.textContent))productTitle.textContent=productTitle.textContent.replace(/^GIFT:\s*/i,'')}rdEnhancePillowSelectorPreview()}
document.addEventListener('DOMContentLoaded',()=>{rdEnhancePillowPurchase();document.querySelectorAll('.rd-pillow').forEach(section=>{const meter=section.querySelector('.rd-pillow__meter');if(!meter)return;if(!('IntersectionObserver'in window)){meter.classList.add('is-visible');return}const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.45});observer.observe(meter)})});
new MutationObserver(rdEnhancePillowPurchase).observe(document.documentElement,{childList:true,subtree:true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
